exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mr-footer .links-wrap button {\n  color: inherit;\n}\n", ""]);

// exports
